window.broker = function () {
	const $broker = $({});

	const trigger = (event, data) => {
		return $broker.trigger(event, data);
	};

	const on = (event, callback) => {
		$broker.on(event, $.proxy(callback, $broker));
	}

	const off = event => {
		$broker.off(event);
	}

	return {
		trigger,
		on,
		off
	};
}();
